import _ from "lodash";
import {
    RECEIVE_INVOICES,
    RECEIVE_INVOICES_FILTER,
    FETCH_INVOICES_REQUEST,
    FETCH_INVOICES_FILTER_REQUEST,
    EXPORT_INVOICE_REQUEST,
    EXPORT_INVOICE_DONE,
    CLEAR_INVOICE_PAGINATION,
    SET_ITEMS_OFFSET,
    SET_FILTERS,
    LOGOUT_SUCCESS,
    RESET_INVOICES
} from '../../../constants';
import { createReducer } from '../../../utils/misc';

export const initialState = {
    isFetching: false,
    loaded: false,
    download_status: {},
    invoice_function: null,
    items: [],
    itemsPage: -1,
    itemsTotal: 0,
    itemsOffset: 0,
    filters: {
        loading: false,
        data: {},
        currentFilter: ''
        // cache: {}
    },
    errors: null
};

export default createReducer(initialState, {
    [RESET_INVOICES]: (state) => {
        return Object.assign({}, state, initialState)
    },
    [RECEIVE_INVOICES]: (state, payload) => {
        return Object.assign({}, state, {
            items: payload.response.items,
            itemsTotal: payload.response.n_items,
            itemsOffset: payload.response.offset,
            itemsPage: payload.response.limit,
            isFetching: false,
            loaded: true,
            errors: payload.errors,
        })
    },
    [SET_ITEMS_OFFSET]: (state, payload) =>
        Object.assign({}, state, {
            itemsOffset: payload.itemsOffset
        }),
    [SET_FILTERS]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: payload.itemsPage,
            itemsOffset: payload.itemsOffset,
            filters: {
                ...state.filters,
                currentFilter: payload.currentFilter
            }
        }),
    [CLEAR_INVOICE_PAGINATION]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: payload.itemsPage,
            itemsTotal: 0,
            itemsOffset: 0,
        }),
    [RECEIVE_INVOICES_FILTER]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: false,
                data: payload
            }
        }),
    [FETCH_INVOICES_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: true,
            loaded: false,
            itemsPage: payload.limit,
            itemsOffset: payload.offset,
            filters: {
                ...state.filters,
                currentFilter: payload.filter
            }
        }),
    [FETCH_INVOICES_FILTER_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: true,
                data: {}
            }
        }),
    [EXPORT_INVOICE_REQUEST]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = true;
        return Object.assign({}, state, {
            download_status,
        });
    },
    [EXPORT_INVOICE_DONE]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = false;
        return Object.assign({}, state, {
            download_status
        });
    },
    [LOGOUT_SUCCESS]: (state, payload) =>
        Object.assign({}, state, initialState),
});
